import { useEffect, useRef, useState } from 'react';

// C-3.1 — Resaltado al llegar por deep-link. Cuando otra pantalla navega con
// ?<param>=<id> (patrón del ?proposal= de SesionesPage), localiza la fila cuyo
// data-testid es `${rowTestIdPrefix}${id}`, hace scroll hasta ella (como el chat)
// y la resalta unos segundos. Devuelve el id resaltado para pintar el anillo.
//
//   `ready`    → los datos ya están pintados (no buscar la fila antes de tiempo).
//   `revision` → cambia cuando cambian las filas visibles (p.ej. tras ajustar un
//                filtro), para re-intentar localizar la fila si aún no existía.
const HIGHLIGHT_MS = 2500;

export function useDeepLinkHighlight(
  id: string | null,
  rowTestIdPrefix: string,
  ready: boolean,
  revision: number = 0
): string | null {
  const [highlighted, setHighlighted] = useState<string | null>(null);
  const doneRef = useRef<string | null>(null);

  useEffect(() => {
    if (!id) {
      doneRef.current = null;
      return;
    }
    if (!ready || doneRef.current === id) return;
    const el = document.querySelector(`[data-testid="${rowTestIdPrefix}${id}"]`);
    if (!el) return; // la fila aún no está pintada; se reintenta al cambiar `revision`
    doneRef.current = id;
    // jsdom no implementa scrollIntoView → optional call (los tests lo mockean).
    (el as HTMLElement).scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    setHighlighted(id);
    const t = window.setTimeout(() => setHighlighted(null), HIGHLIGHT_MS);
    return () => window.clearTimeout(t);
  }, [id, rowTestIdPrefix, ready, revision]);

  return highlighted;
}
